const councilPageTypeVariants = {
	COUNCILPAGE: 'councilPage',
};

export default councilPageTypeVariants;
